<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{
          $t("pages_banners_index_178")
        }}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="printer_configs"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal
      v-model="modalShow"
      @on-ok="handleSubmit"
      :title="$t('pages_printer_index_719')"
    >
      <Form ref="printer_config" :model="form" :label-width="100">
        <Form-item :label="$t('pages_ai_image_158')" prop="title">
          <Input type="text" v-model="form.title" />
        </Form-item>
        <Form-item :label="$t('pages_printer_index_720')">
          <Select
            label-in-value
            @on-change="
              (e) => {
                this.change_from_value('kind', e);
              }
            "
            v-model="form.kind"
          >
            <Option v-for="item in kinds" :value="item.code" :key="item.code">{{
              item.text
            }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_banners_index_185')">
          <Select
            label-in-value
            @on-change="
              (e) => {
                this.change_from_value('change_printer_type', e);
              }
            "
            v-model="form.printer_type"
          >
            <Option
              v-for="item in printer_types"
              :value="item.code"
              :key="item.code"
              >{{ item.text }}</Option
            >
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_printer_index_721')">
          <Select
            label-in-value
            @on-change="
              (e) => {
                this.change_from_value('change_receipt_width', e);
              }
            "
            v-model="form.receipt_width"
          >
            <Option
              v-for="item in receipt_widths"
              :value="item.code"
              :key="item.code"
              >{{ item.text }}</Option
            >
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_printer_index_722')">
          <i-switch
            v-model="form.select_all_category"
            size="large"
            @on-change="
              (val) => {
                this.change_from_value('select_all_category', { value: val });
              }
            "
          >
          </i-switch>
        </Form-item>
        <Form-item
          :label="$t('pages_printer_index_723')"
          v-if="!form.select_all_category"
        >
          <Select
            label-in-value
            multiple
            @on-change="
              (e) => {
                this.change_from_value('printable_category_ids', e);
              }
            "
            v-model="form.printable_category_ids"
          >
            <Option
              v-for="item in categories"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Form-item>
        <Form-item
          :label="$t('pages_printer_index_724')"
          v-if="form.printer_type === 'gprs'"
        >
          <Select
            label-in-value
            @on-change="
              (e) => {
                this.change_from_value('channel', e);
              }
            "
            v-model="form.channel"
          >
            <Option
              v-for="item in channels"
              :key="item.code"
              :value="item.code"
              >{{ item.text }}</Option
            >
          </Select>
        </Form-item>
        <Form-item
          :label="$t('pages_printer_index_724')"
          v-if="form.printer_type === 'gprs'"
        >
          <el-input v-model="form.cloud_printer_no">
            <template slot="append">
              <el-popover
                slot="append"
                placement="top"
                width="200"
                trigger="click"
              >
                <img style="width: 200px" src="@/assets/images/gprs-case.jpg" />
                <el-button slot="reference" size="mini" icon="el-icon-view">{{
                  $t("pages_printer_index_725")
                }}</el-button>
              </el-popover>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('pages_printer_index_726')"
                placement="top"
              >
              </el-tooltip>
            </template>
          </el-input>
        </Form-item>
        <Form-item :label="$t('pages_printer_index_740')" prop="key" v-if="form.channel == 'feie'">
          <Input type="text" v-model="form.key" />
        </Form-item>
        <Form-item :label="$t('pages_printer_index_727')">
          <printer-receipt-attributes
            v-model="form.printer_receipt_configs_attributes"
          ></printer-receipt-attributes>
        </Form-item>

        <Form-item :label="$t('pages_settings_index_969')">
          <i-select
            @on-change="
              (e) => {
                this.change_from_value('fresh_package_id', e);
              }
            "
            v-model="form.fresh_package_id"
          >
            <i-option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">{{
              pkg.title
            }}</i-option>
          </i-select>
          <div v-if="selectedPkg.id">
            <div>规格：{{ selectedPkg.spec || "未设置规格" }}</div>
            <p>{{ $t("pages_settings_index_971") }}</p>
            <a v-if="selectedPkg.picture" :href="selectedPkg.picture">
              <img :src="selectedPkg.picture" width="220px" />
            </a>
            <div
              v-else
              style="
                background: #ddd;
                height: 100px;
                text-align: center;
                line-height: 100px;
                color: #999;
              "
            >
              <h2>{{ $t("pages_settings_index_972") }}</h2>
            </div>
          </div>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from "../../locales/index";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import TablePaginate from "@/components/TablePaginate";
import PrinterReceiptAttributes from "./components/printer-receipt-attributes";
import { deleteButtonInTable, editorButtonInTable } from "@/libs/table-render";

export default {
  components: {
    TablePaginate,
    PrinterReceiptAttributes,
  },
  watch: {
    printer_config(val) {
      if (val && val.id) {
        console.log("val", val);
        this.form = {
          ...val,
          printer_receipt_configs_attributes: val.printer_receipt_configs,
          channel: val.cloud_printer_channel,
        };
      }
    },
  },
  data() {
    return {
      printer_types: [
        { text: i18n.t("pages_printer_index_728"), code: "usb" },
        { text: i18n.t("pages_printer_index_729"), code: "gprs" },
        { text: i18n.t("pages_printer_index_730"), code: "network" },
        { text: i18n.t("pages_printer_index_731"), code: "bluetooth" },
      ],
      receipt_widths: [
        { text: "58", code: "58" },
        { text: "80", code: "80" },
      ],
      kinds: [
        { text: i18n.t("libs_table_render_51"), code: "reception" },
        { text: i18n.t("pages_printer_index_732"), code: "kitchen" },
      ],
      channels: [
        { text: i18n.t("pages_printer_index_733"), code: "fukun" },
        { text: "DR", code: "jiabo" },
        { text: i18n.t("pages_printer_index_734"), code: "fukun_cloud" },
        { text: i18n.t("pages_printer_index_737"), code: "feie" },
        { text: i18n.t("pages_printer_index_738"), code: "xinye" },
        { text: i18n.t("pages_printer_index_739"), code: "hanyin" },
      ],
      form: {
        title: "",
        link: "",
        platform: "",
        category: "",
        image: "",
        fresh_package_id: "",
      },
      modalShow: false,
      formType: "",
      columns: [
        {
          title: i18n.t("pages_ai_image_158"),
          key: "title",
        },
        {
          title: i18n.t("pages_printer_index_736"),
          key: "printer_type",
          width: 150,
          align: "center",
        },
        {
          title: i18n.t("pages_printer_index_721"),
          key: "receipt_width",
          width: 150,
          align: "center",
        },
        {
          title: i18n.t("pages_balance_transaction_index_176"),
          key: "printer_receipt_configs",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.row.printer_receipt_configs &&
                params.row.printer_receipt_configs[0].state === "on"
                ? "开启"
                : i18n.t("pages_birthday_discount_index_209")
            );
          },
        },
        {
          title: i18n.t("pages_ai_image_163"),
          key: "action",
          width: 200,
          fixed: "right",
          align: "center",
          render: (h, params) => {
            const children = [];
            children.push(deleteButtonInTable(this, h, params));
            children.push(editorButtonInTable(this, h, params));
            return h("div", children);
          },
        },
      ],
    };
  },
  created() {
    this.changeQuery({ page: 1 });
    this.fetchPackages({ page: 1, per: 65536 });
    this.index();
    this.categoryIndex();
  },
  computed: {
    ...mapGetters("printer_config", [
      "printer_config",
      "printer_configs",
      "meta",
      "loading",
    ]),
    ...mapGetters("category", ["categories"]),
    ...mapState("package", ["packages"]),
    selectedPkg() {
      const id = this.form.fresh_package_id;
      const pkg = this.packages.find((i) => i.id === id);
      return pkg || {};
    },
  },
  methods: {
    savePackageId(e) {
      // await this.upgrade({ package_id: parseFloat(this.form.package_id) });
      // this.form.fresh_package_id =
      console.log(e);
    },
    ...mapActions("printer_config", [
      "clearRecord",
      "index",
      "show",
      "create",
      "update",
      "destroy",
    ]),
    ...mapActions("package", {
      fetchPackages: "index",
    }),
    ...mapActions("category", {
      categoryIndex: "index",
    }),
    ...mapMutations("printer_config", ["changeQuery"]),
    changePage(page) {
      this.changeQuery({ page: page });
      this.index();
    },
    change_from_value(prop, e) {
      console.log(Object.prototype.toString.call(e))
      if (Object.prototype.toString.call(e) === "[object Object]") {
        this.form[prop] = e.value;
      }

      if (Object.prototype.toString.call(e) === "[object Number]") {
        this.form[prop] = e;
      }
      console.log("this.form", this.form);
    },
    add() {
      this.clearRecord();
      this.form = {};
      this.modalShow = true;
      this.formType = "new";
    },
    async handleSubmit() {
      if (this.formType === "edit") {
        await this.update(this.form);
      } else if (this.formType === "new") {
        await this.create(this.form);
      }
      this.modalShow = false;
    },
  },
};
</script>
